import { DialogLocal } from "@/components/Dialog";
import { Input } from "@/components/Input";
import SubLayout from "@/components/SubLayout";
import { AutoCenter, Button, Form, Toast } from "antd-mobile";
import { useSetup, validateFields } from "./logic";
export function PageUserAccount() {
  const store = useSetup();
  const onSubmit = async () => {
    const values = await store.form.validateFields();
    const validateResult = validateFields(values, {
      isBindPwd: store.isBindPwd
    });
    if (typeof validateResult === "string") {
      return Toast.show(validateResult);
    }
    DialogLocal({
      content: <AutoCenter>
          <div>
            为保障您的资金安全，资金密码修改后
            <span style={{
            color: "#fb2222ff"
          }}> 2小时 </span>
            以内不允许交易
          </div>
        </AutoCenter>,
      onConfirm() {
        if (store.isBindPwd) {
          store.fetchResetPwd(values);
        } else {
          store.fetchSetPwd(values);
        }
      }
    });
  };
  return <SubLayout title={`${store.isBindPwd ? "修改" : "设置"}资金密码`} footer={<Button className={"common-submit-button"} onClick={() => {
    onSubmit();
  }}>
          确定
        </Button>} data-sentry-element="SubLayout" data-sentry-component="PageUserAccount" data-sentry-source-file="index.tsx">
      <Form form={store.form} className={"common-form"} data-sentry-element="Form" data-sentry-source-file="index.tsx">
        {store.isBindPwd ? <Form.Item name="oldSecPassword" label="旧密码">
            <Input placeholder="资金密码为6位纯数字" type={"password"} maxLength={6} />
          </Form.Item> : null}

        <Form.Item name="newSecPassword" label={`${store.isBindPwd ? "新" : ""}密码`} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input placeholder="资金密码为6位纯数字" type={"password"} maxLength={6} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>

        <Form.Item name="confirmSecPassword" label={`确认${store.isBindPwd ? "新" : ""}密码`} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
          <Input placeholder="资金密码为6位纯数字" type={"password"} maxLength={6} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        </Form.Item>
      </Form>
    </SubLayout>;
}